import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "select-file__header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 手动添加 ")
const _hoisted_3 = { class: "select-file__footer" }
const _hoisted_4 = ["disabled", "onClick"]

import { onMounted, ref, computed } from 'vue'
import { IconClose, IconLoading2 } from '@xunlei/thunder-icon-vue'
import { usePromisifyDialog } from '@shared/utils/dialog'
import FileExplorer from '@remote/components/base/FileExplorer.vue'


export default /*#__PURE__*/_defineComponent({
  emits: ["dialog-close"],
  setup(__props, { emit }: { emit: ({
  (e: 'dialog-close', paths?: (string | undefined)[]): void
}), expose: any, slots: any, attrs: any }) {

const isMountedRef = ref(false)


const isLoading = ref(false)

const { close } = usePromisifyDialog(emit)

const chosenFiles = ref<string[]>([])

const typeGuard = (val: (API_FILE.DriveFile | API_DEVICE.HistoryDownloadPath)): val is API_FILE.DriveFile => {
  return !!(val as API_FILE.DriveFile).id
}

const updateChosenFiles = (val: (API_FILE.DriveFile | API_DEVICE.HistoryDownloadPath)[]) => {
  chosenFiles.value = val.map(i => {
    if (typeGuard(i)) {
      return i?.params?.RealPath ?? ''
    } else {
      return i.RealPath ?? ''
    }
  })
}

const fileExplorer = ref<null | InstanceType<typeof FileExplorer>>(null)

const handleClose = (paths: (string | undefined)[]) => {
  isMountedRef.value = false
  setTimeout(() => {
    close(paths)
  }, 300)
}

const isAnyPathChecked = computed(() => {
  return chosenFiles.value.length > 0
})

const onConfirm = () => {
  handleClose(chosenFiles.value)
}

onMounted(async () => {
  setTimeout(() => {
    isMountedRef.value = true
  }, 0)
})




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass(["pop-wrapper", {'is-mounted': isMountedRef.value}]),
      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (handleClose([])), ["stop"]))
    }, [
      _createElementVNode("div", {
        class: "nas-remote__select-file is-dark",
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h2", null, [
            _hoisted_2,
            _withDirectives(_createVNode(_unref(IconLoading2), {
              width: "24",
              height: "24"
            }, null, 512), [
              [_vShow, isLoading.value]
            ])
          ]),
          _createVNode(_unref(IconClose), {
            width: "24",
            height: "24",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (handleClose([])), ["stop"]))
          })
        ]),
        _createVNode(FileExplorer, {
          ref_key: "fileExplorer",
          ref: fileExplorer,
          "default-select": false,
          "onUpdate:chosenList": updateChosenFiles,
          "is-loading": isLoading.value,
          "onUpdate:is-loading": _cache[1] || (_cache[1] = ($event: any) => ((isLoading).value = $event))
        }, null, 8, ["is-loading"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass({ 'button-base': true, 'primary-button': true, 'is-disabled': !_unref(isAnyPathChecked) }),
            disabled: !_unref(isAnyPathChecked),
            onClick: _withModifiers(onConfirm, ["stop"])
          }, " 确认添加 ", 10, _hoisted_4)
        ])
      ])
    ], 2)
  ]))
}
}

})